import { classNames } from "primereact/utils";
import { IOnboardingStep } from "./flows/onboardingTypes";
import styles from "./styles/onboarding.module.scss";

interface IOnboardingStepItemProps {
  step: IOnboardingStep;
  isPending: boolean;
  isActive: boolean;
  onClick: () => void;
}

export const OnboardingStepItem = ({
  step,
  isPending,
  isActive,
  onClick,
}: IOnboardingStepItemProps) => {
  const isCompleted = !isPending;

  return (
    <div
      className={classNames(styles.stepItem, {
        [styles.stepItemActive]: isActive,
      })}
      onClick={onClick}
    >
      <div
        className={classNames(styles.stepItemIcon, {
          [styles.stepItemIconCompleted]: isCompleted,
        })}
      >
        {isCompleted && (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M2 6L5 9L10 3"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span
        className={classNames(styles.stepItemLabel, {
          [styles.stepItemLabelCompleted]: isCompleted,
        })}
      >
        {step.title}
        {step.optional && (
          <span className={styles.stepItemOptionalBadge}>незадължително</span>
        )}
      </span>
    </div>
  );
};
